export const TabRestaurantPro = [
  {
    id: 2,
    isVisible: true,
    link: '/subscription-sales/restaurant-essentials/',
    blocked: '/subscription-sales/restaurant-essentials/blocked',
    title: 'Recipes & ingredients',
    type: 'dropdown',
    access: 'recipe_ingridient',
    isGranted: true,
    subTab: [
      {
        id: 2,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/recipes/ingredients-library',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Ingredients library',
        type: 'link',
        access: 'recipe_ingridient',
        isGranted: true,
      },
      {
        id: 2,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/recipes/inflow',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Inflows',
        type: 'link',
        access: 'recipe_ingridient',
        isGranted: true,
      },
      {
        id: 2,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/recipes/outflow',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Outflows',
        type: 'link',
        access: 'recipe_ingridient',
        isGranted: true,
      },
      {
        id: 2,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/recipes/process-rule',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Process rule',
        type: 'link',
        access: 'recipe_ingridient',
        isGranted: true,
      },
      {
        id: 2,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/recipes/ingredients-history',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Ingredients history',
        type: 'link',
        access: 'recipe_ingridient',
        isGranted: true,
      },
      // {
      //   id: 2,
      //   isVisible: false,
      //   link: '/subscription-sales/restaurant-essentials/recipes/recipe-book',
      //   blocked: '/subscription-sales/restaurant-essentials/blocked',
      //   title: 'Recipe book',
      //   type: 'link',
      //   access: 'recipe_book_reads',
      //   isGranted: true,
      // },
    ],
  },
  {
    id: 9,
    isVisible: false,
    title: 'Table management',
    type: 'dropdown',
    access: 'table_management',
    blocked: '/subscription-sales/restaurant-essentials/blocked',
    isGranted: true,
    subTab: [
      {
        id: 4,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/floor-plans',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Floor plans',
        type: 'link',
        access: 'table_management',
        isGranted: true,
      },
      {
        id: 5,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/sections',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Sections',
        type: 'link',
        access: 'table_management',
        isGranted: true,
      },
    ],
  },
  {
    id: 312893081319238,
    isVisible: false,
    link: '/subscription-sales/restaurant-essentials/kitchen-display',
    blocked: '/subscription-sales/restaurant-essentials/blocked',
    title: 'Kitchen display system',
    type: 'link',
    access: 'kds',
    isGranted: true,
  },
  {
    id: 31289308131923768,
    isVisible: false,
    link: '/subscription-sales/restaurant-essentials/menus',
    blocked: '/subscription-sales/restaurant-essentials/blocked',
    title: 'Menus',
    type: 'link',
    access: 'menus',
    isGranted: true,
  },
  // {
  //   id: 34242342424,
  //   isVisible: false,
  //   link: '/subscription-sales/restaurant-essentials/self-ordering/self-service-kiosk',
  //   blocked: '/subscription-sales/restaurant-essentials/blocked',
  //   title: 'Self-ordering',
  //   type: 'dropdown',
  //   subTab: [
  //     {
  //       id: 4,
  //       isVisible: false,
  //       link: '/subscription-sales/restaurant-essentials/self-ordering/self-service-kiosk',
  //       blocked: '/subscription-sales/restaurant-essentials/blocked',
  //       title: 'Self-service kiosks',
  //       access: 'self_ordering',
  //       isGranted: true,
  //       type: 'link',
  //     },
  //     {
  //       id: 5,
  //       isVisible: false,
  //       link: '/subscription-sales/restaurant-essentials/self-ordering/qr-code',
  //       blocked: '/subscription-sales/restaurant-essentials/blocked',
  //       title: 'QR codes',
  //       access: 'self_ordering',
  //       isGranted: true,
  //       type: 'link',
  //     },
  //   ],
  // },
  {
    id: 34242342424755,
    isVisible: false,
    link: '/subscription-sales/basic-sales/compliments-voids',
    blocked: '/subscription-sales/restaurant-essentials/blocked',
    title: 'Restaurant reports',
    type: 'dropdown',
    access: 'restaurant_report',
    isGranted: true,
    subTab: [
      {
        id: 4,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/reports/ingredients',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Ingredients report',
        type: 'link',
        access: 'restaurant_report',
        isGranted: true,
      },
      {
        id: 5,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/reports/kitchen-performance',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Kitchen performance',
        type: 'link',
        access: 'restaurant_report',
        isGranted: true,
      },
      // {
      //   id: 6,
      //   isVisible: false,
      //   link: "/subscription-sales/restaurant-essentials/reports/self-order",
      //   title: "Self-ordering report",
      //   type: "link",
      // },
    ],
  },
  {
    id: 342423424242323,
    isVisible: false,
    link: '/subscription-sales/restaurant-essentials/settings',
    blocked: '/subscription-sales/restaurant-essentials/blocked',
    title: 'Restaurant settings',
    type: 'dropdown',
    access: 'restaurant_settings',
    isGranted: true,
    subTab: [
      {
        id: 4,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/settings/unit-measurement',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Unit of measurements',
        type: 'link',
        access: 'restaurant_settings',
        isGranted: true,
      },
      {
        id: 5,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/settings/ingredients-states',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Ingredient states',
        type: 'link',
        access: 'restaurant_settings',
        isGranted: true,
      },
      {
        id: 6,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/settings/ingredients-types',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Ingredient types',
        type: 'link',
        access: 'restaurant_settings',
        isGranted: true,
      },
      {
        id: 73984,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/settings/dish-types',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Dish types',
        type: 'link',
        access: 'restaurant_settings',
        isGranted: true,
      },
    ],
  },
];
